import React, { Component } from 'react'
import _ from 'lodash'
import { RoleCode } from './constants'
import 'antd/dist/antd.css'
import './App.scss'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'
import { observer, Provider } from 'mobx-react'
import { ApolloProvider } from 'react-apollo'
import { compose } from 'recompose'
import client, { cache } from './ApolloClient'

// pages
import LoginPage from './pages/Auth/login'
import ChangePasswordPage from './pages/Auth/login/changePassword'
import Dashboard from './pages/App/dashboard'

// Resident profile
import Constituents from './pages/ResidentProfile/Constituents'
import Household from './pages/ResidentProfile/Households'
import ManageHousehold from './pages/ResidentProfile/Households/manage'

// Certificates
import CertificateResidency from './pages/Certificates/Residency'
import CertificateResidencyApplication from './pages/Certificates/ResidencyApplication'
import CertificateResidencyCapitol from './pages/Certificates/ResidencyCapitol'
import CertificateLateRegistry from './pages/Certificates/LateRegistry'
import CertificateLoanClearance from './pages/Certificates/LoanClearance'
import CertificateIndigency from './pages/Certificates/Indigency'
import CertificateIndigencySoloparent from './pages/Certificates/IndigencySoloparent'
import CertificateIndigencyCityhall from './pages/Certificates/IndigencyCityhall'
import CertificateGuardianship from './pages/Certificates/Guardianship'
import CertificateBarangayClearance from './pages/Certificates/BarangayClearance'
import CertificateConstructionClearance from './pages/Certificates/ConstructionClearance'
import CertificateBusinessClearance from './pages/Certificates/BusinessClearance'
import CertificateTricycleClearance from './pages/Certificates/TricycleClearance'
import CertificateCommunityTaxClearance from './pages/Certificates/CommunityTax'
import CustomCertificate from './pages/Certificates/Custom'
import CertificateDiscrepancy from './pages/Certificates/Discrepancy'
import CertificateBoat from './pages/Certificates/BoatClearance'
import CertificateBurial from './pages/Certificates/Burial'
import OfficialReceipt from './pages/Certificates/OfficialReceipt'

// other certifications
import CertificateCommonLaw from './pages/Certificates/OtherCertifications/CommonLaw'
import CertificatePenelco from './pages/Certificates/OtherCertifications/Penelco'
import CertificatePenelcoBapa from './pages/Certificates/OtherCertifications/PenelcoBapa'
import CertificateKin from './pages/Certificates/OtherCertifications/NextKin'
import CertificateBusinessClosure from './pages/Certificates/OtherCertifications/BusinessClosure'
import CertificateScholarship from './pages/Certificates/OtherCertifications/Scholarship'
import CertificateBusinessPermit from './pages/Certificates/OtherCertifications/BusinessPermit'

// Barangay Issues
import Complain from './pages/BarangayIssue'
import ComplainDetails from './pages/BarangayIssue/viewDetails'
import Blotter from './pages/Blotter'
import BlotterDetails from './pages/Blotter/viewDetails'

// DTR
import DTRDashboard from './pages/DTR/dashboard'

// Barangay Management
import Events from './pages/Management/Events'
import FacilitiesReservation from './pages/Management/Facilities'
import Equipments from './pages/Management/Equipments'
import Projects from './pages/Management/Projects'
import Resolutions from './pages/Management/Resolutions'

// utilties
import Officers from './pages/Utilities/Officers'
import DataLookupManagement from './pages/Utilities/LookupManagement'
import SystemSettings from './pages/Utilities/SystemSettings'
import SystemUsers from './pages/Utilities/SystemUsers'
import DatabaseBackup from './pages/Utilities/DatabaseBackup'
import VisitorQRGenerator from './pages/Utilities/VisitorQRGenerator'
import AuditTrail from './pages/Utilities/AuditTrail'

// medical records
import MedicalRecords from './pages/MedicalRecords'

import Notifications from './pages/Notifications'

import Reports from './pages/Reports'

//Template
// import LoginTemplate from './pages/Auth/login/Header'
import Template from './pages/App/app'

// Store
import AppStore from './pages/App/store'
import AuthStore from './pages/Auth/store'

// offline settings, comment all the way to waitonCache to remove offline capability
import { persistCache } from 'apollo-cache-persist'

// const CAN_OFFLINE = JSON.parse(process.env.REACT_APP_CAN_OFFLINE)
const CAN_OFFLINE = false

export const waitOnCache = () => {
	if (!CAN_OFFLINE)
		return null

	const storage = window.localStorage
	return persistCache({ cache, storage })
}


const stores = { AppStore, AuthStore }

class App extends Component {

	render() {
		console.log('[DEV BUILD VERSION]', process.env.REACT_APP_DEV_VERSION)

		const { isAuthenticated, isPasswordChanged, userDetails, toArray } = AuthStore
		const mUserDetails = toArray(userDetails) || {}
		const mUserType = mUserDetails.user_type || null
		
		console.log('mUserDetails', mUserDetails)
		console.log('isAuthenticated', isAuthenticated)
		console.log('isPasswordChanged', isPasswordChanged)
		console.log('mUserType', mUserType)

		// set dynamic favicon based from system settings
		if (_.has(mUserDetails, 'uid') && mUserDetails.barangay_logo_url) {
			var link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
			link.type = 'image/x-icon'
			link.rel = 'shortcut icon'
			link.href = `${process.env.REACT_APP_BACKEND_API}${mUserDetails.barangay_logo_url}`
			document.getElementsByTagName('head')[0].appendChild(link)
		}

		const PrivateRoute = ({ component: Component, ...rest }) => {
			return (
				<Route
					{...rest}
					render={props => {
						if (isAuthenticated && isPasswordChanged) {
							return (<Component client={client} {...props} />)
						} else if (isAuthenticated && !isPasswordChanged) {
							return (
								<Redirect
									to={{
										pathname: '/update-password',
										// state: { from: props.location }
									}}
								/>
							)
						} else {
							return (
								<Redirect
									to={{
										pathname: '/',
										state: { from: props.location }
									}}
								/>
							)
						}
						// return isAuthenticated ? (
						// 	<Component client={client} {...props} />
						// ) : (
						// 	<Redirect
						// 		to={{
						// 			pathname: '/',
						// 			state: { from: props.location }
						// 		}}
						// 	/>
						// )
					}}
				/>
			)
		}

		return (
			<ApolloProvider client={client}>
				<Router>
					<React.Fragment>
						<Provider {...stores}>
							<Switch>
								{/* {
									!isAuthenticated &&
									<Route exact path="/signup" component={SignupPage} />
								} */}
								{
									!isAuthenticated &&
									<Route exact path="/" component={LoginPage} />
								}
								
								<Route exact path="/update-password" component={ChangePasswordPage} />

								{/* DTR pages */}
								<Route exact path="/dtr" component={DTRDashboard} />

								<Template isAuthenticated={isAuthenticated}>
									<PrivateRoute exact path="/" component={Dashboard} />

									{/* use exact when specific page, when using children remove exact property */}

									{/* Resident Profile pages */}
									<PrivateRoute exact path="/constituents" component={Constituents} />
									<PrivateRoute exact path="/household" component={Household} />
									<PrivateRoute exact path="/household/manage" component={ManageHousehold} />

									{/* Certificates pages */}
									<PrivateRoute exact path="/certificate/residency" component={CertificateResidency} />
									<PrivateRoute exact path="/certificate/residency-application" component={CertificateResidencyApplication} />
									<PrivateRoute exact path="/certificate/residency-capitol" component={CertificateResidencyCapitol} />
									<PrivateRoute exact path="/certificate/late-registry" component={CertificateLateRegistry} />
									<PrivateRoute exact path="/certificate/loan-clearance" component={CertificateLoanClearance} />
									<PrivateRoute exact path="/certificate/indigency" component={CertificateIndigency} />
									<PrivateRoute exact path="/certificate/indigency-solo-parent" component={CertificateIndigencySoloparent} />
									<PrivateRoute exact path="/certificate/indigency-city" component={CertificateIndigencyCityhall} />
									<PrivateRoute exact path="/certificate/guardianship" component={CertificateGuardianship} />
									<PrivateRoute exact path="/certificate/barangay-clearance" component={CertificateBarangayClearance} />
									<PrivateRoute exact path="/certificate/construction-clearance" component={CertificateConstructionClearance} />
									<PrivateRoute exact path="/certificate/business-clearance" component={CertificateBusinessClearance} />
									<PrivateRoute exact path="/certificate/tricycle-clearance" component={CertificateTricycleClearance} />
									<PrivateRoute exact path="/certificate/community-tax" component={CertificateCommunityTaxClearance} />
									<PrivateRoute exact path="/certificate/custom" component={CustomCertificate} />
									<PrivateRoute exact path="/certificate/discrepancy" component={CertificateDiscrepancy} />
									<PrivateRoute exact path="/certificate/boat" component={CertificateBoat} />
									<PrivateRoute exact path="/certificate/burial" component={CertificateBurial} />
									<PrivateRoute exact path="/certificate/official-receipt" component={OfficialReceipt} />

									{/* Other Certification */}
									<PrivateRoute exact path="/certificate/common-law" component={CertificateCommonLaw} />
									<PrivateRoute exact path="/certificate/penelco" component={CertificatePenelco} />
									<PrivateRoute exact path="/certificate/bapa-penelco" component={CertificatePenelcoBapa} />
									<PrivateRoute exact path="/certificate/kin" component={CertificateKin} />
									<PrivateRoute exact path="/certificate/business-closure" component={CertificateBusinessClosure} />
									<PrivateRoute exact path="/certificate/scholarship" component={CertificateScholarship} />
									<PrivateRoute exact path="/certificate/business-permit" component={CertificateBusinessPermit} />

									{/* Barangay issues page */}
									<PrivateRoute exact path="/complains" component={Complain} />
									<PrivateRoute exact path="/complains/details/:complain_uid" component={ComplainDetails} />

									{/* Blotter page */}
									<PrivateRoute exact path="/blotter" component={Blotter} />
									<PrivateRoute exact path="/blotter/details/:blotter_uid" component={BlotterDetails} />

									{/* Event and Facilities reservation page */}
									<PrivateRoute exact path="/events" component={Events} />
									<PrivateRoute exact path="/reservation" component={FacilitiesReservation} />
									<PrivateRoute exact path="/equipment" component={Equipments} />
									<PrivateRoute exact path="/projects" component={Projects} />
									<PrivateRoute exact path="/resolutions" component={Resolutions} />

									{/* Utilities Pages */}
									<PrivateRoute exact path="/utilities/officials" component={Officers} />
									<PrivateRoute exact path="/utilities/lookups" component={DataLookupManagement} />
									<PrivateRoute exact path="/utilities/settings" component={SystemSettings} />
									<PrivateRoute exact path="/utilities/users" component={SystemUsers} />
									<PrivateRoute exact path="/utilities/database-backup" component={DatabaseBackup} />
									<PrivateRoute exact path="/utilities/visitor-qr-generator" component={VisitorQRGenerator} />
									<PrivateRoute exact path="/utilities/audit-trail" component={AuditTrail} />

									{/* Notifications page */}
									<PrivateRoute exact path="/notifications" component={Notifications} />

									{/* Medical Records page */}
									<PrivateRoute exact path="/medical" component={MedicalRecords} />

									{/* Reports page */}
									<PrivateRoute exact path="/reports" component={Reports} />
								</Template>
							</Switch>
						</Provider>
					</React.Fragment>
				</Router>
			</ApolloProvider>

		)
	}
}

const composed = compose(observer)

export default composed(App)
